// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-rewriter.js?{"id":"data-v-2008861a","scoped":true,"hasInlineConfig":false}!./src/components/entry-points/create-new-entry-point/CreateNewEntryPoint.css
// module id = HkLJ
// module chunks = 1